<template>
  <div class="main clean">
    <div class="mseciton">
      <Header></Header>
    </div>
  <div class="content ">
    <div class="contact">
      <p class="title">Destroy Data</p>
      <div class="value"><input class="email" type="text" name="email" placeholder="Please enter your email address"></div>
      <div class="button" @click.stop="onSubmit">Submit</div>
      <div class="tips2"></div>
    </div>
  </div>
  <Footer></Footer>
  </div>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";

export default {
  components: {Header, Footer},
  name: 'DestroyData',
  data() {
    return {
      timer: null,
    }
  },
  methods: {
    showTips(txt) {
      let tipDom = document.querySelector('.tips2')
      if (this.timer !== null) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      tipDom.innerText = txt;
      tipDom.classList.add('show');
      this.timer = setTimeout(function() {
        tipDom.classList.remove('show');
      }, 2000);
    },
    onSubmit() {
      if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/i.test(document.querySelector('.email').value)) {
        this.showTips('The request has been submitted, and the data will be cleared within 30 days.');
      } else {
        this.showTips('Please enter the correct email address.');
      }
    }
  }
};
</script>

<style lang="less" scoped>
.main.clean{
  .mseciton{
    background-image: none;
    height: auto;
    min-height: auto;
    background-color: #000;
    padding: 0;
    background-color: transparent;
    ::v-deep{
      header{
        padding-top: 0;
        border-bottom: 1px solid #eee;
      }
    }
  }
}
.content{
  min-height: calc(100vh - 142px);
  background-color: #fff;
  .title{
    color: #333;
  }
}

.tips2{
  color: #fff;
  font-size: 14px;
  position: absolute;
  bottom: 3px;
  left: 50%;
  transform: translate(-50%, 250%);
  background-color: #000;
  padding: 8px 16px;
  border-radius: 20px;
  transition: all;
  transition-duration: .25s;
  opacity: 0;
  min-width: 300px;
}
.tips2.show{
  opacity: 1;
  bottom: 25px;
}
.title{
  text-align: center;
}
input{
  width: 240px;
  height: 32px;
  line-height: 32px;
  font-size: 16px;
  &::placeholder{
    font-size: 14px;
  }
}
.button{
  border: 1px solid #d6d6d6;
  line-height: 32px;
  border-radius: 3px;
  background-color: #f2f2f3;
  text-align: center;
  margin: 22px auto;
  height: 32px;
  width: 90px;
  cursor: pointer;
}
.content {
  padding: 10px 0;
  flex: 1;
  // background-image: url("~@/assets/images/contact.png");
  background-size: cover;
  width: 100%;
  display: flex;
  align-items: center;
  .contact {
    // transform: translateX(-100%);
    position: relative;
    .desc {
      div {
        margin-bottom: 15px;
      }
      ul {
        margin-top: 10px;
      }
      ul li {
        margin-left: 20px;
        font-size: 12px;
      }
    }
  }
}
</style>